module.exports = __webpack_public_path__ + "static/media/17.4fc1eab7.jpeg";